import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Button, TextField } from '@material-ui/core';
import { conver, timeFormat2 } from '../../../common/utils';

const Root = styled(Box)({
    width: '700px',
    padding: '40px',
    '& .title': {
        color: '#0060A0',
        marginBottom: '40px',
        fontSize: '18px',
        fontWeight: 'bold',
    },
    '& .textWapper': {
        width: '70%',
        paddingBottom: '15px',
        '& .textField': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
        '& .textTitle': {
            marginTop: '10px',
            fontSize: '14px',
            color: '#9B9B9B',
        },
    },
    '& .fileWapper': {
        marginBottom: '15px',
        // color: '#9B9B9B',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#A1A1A1',
        margin: '20px 0',
        opacity: '0.12',
    },
    '& .w-100': {
        width: '100%',
    },
})

class UploadView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: "",
            fileName: "",
            fileSize: "",
            fileData: "",
        }
    }
    render() {
        const {
            date,
            fileName,
            fileSize,
            fileData,
        } = this.state;
        const { isUpload } = this.props;
        this.handleChange = this.handleChange.bind(this);
        this.handleChooseFile = this.handleChooseFile.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleCapture = this.handleCapture.bind(this);
        this.handleSave = this.handleSave.bind(this);
        const fileInfo = () => {
            if (fileName) {
                return <div className="fileWapper">
                    <div>File Name: {fileName}</div>
                    <div>File Size: {conver(fileSize)}</div>
                </div>
            }
        }
        const chooseFileBtn = () => {
            if (isUpload) {
                return <Button component="label" variant="outlined" color="primary">CHOOSE A FILE
                <input
                        type="file"
                        style={{ display: "none" }}
                        onChange={this.handleCapture}
                    />
                </Button>
            }
        }
        const saveBtn = () => {
            if (isUpload) {
                return <Button disabled={fileData ? false : true} variant="contained" color="primary" onClick={this.handleUpload}>CONFIRM TO UPLOAD</Button>
            } else {
                return <Button variant="contained" color="primary" onClick={this.handleSave}>save change</Button>
            }
        }
        return (
            <Root>
                <div className="title c">PLEASE UPLOAD A FILE</div>
                <div className="textWapper">
                    <div className="textTitle">Document Signning Date</div>
                    <TextField
                        type="date"
                        className="textField"
                        value={timeFormat2(date)}
                        onChange={this.handleChange}
                        margin="dense"
                        variant="outlined"
                    />
                </div>
                {fileInfo()}
                {chooseFileBtn()}
                <div className="line"></div>
                <div className="w-100 h h-r">
                    {saveBtn()}
                </div>
            </Root>
        )
    }
    componentDidMount() {
        const { data } = this.props;
        const date = data.signed_date;
        if (date) {
            this.setState(() => ({
                date: timeFormat2(date)
            }))
        } else {
            this.setState(() => ({
                date: timeFormat2(new Date())
            }))
        }
    }
    handleChange(e) {
        const value = e.target.value;
        this.setState(() => ({
            date: value
        }))
    }
    handleChooseFile(e) {
    }
    handleUpload(e) {
        const { date, fileData } = this.state;
        this.props.handleUploadFile(date, fileData);
    }
    handleSave(e) {
        const { date } = this.state;
        this.props.handleSaveChange(date);
    }
    handleCapture(e) {
        const file = e.target.files[0];
        console.log(file)
        if (!file) return;
        const fileName = file.name ? file.name : "";
        const fileSize = file.size ? file.size : "";
        const fileData = file;
        this.setState(() => ({
            fileName,
            fileSize,
            fileData
        }));
    }
    clearFile() {
        this.setState(() => ({
            fileName: "",
            fileSize: "",
            fileData: ""
        }));
    }
}

export default UploadView;